import { render, staticRenderFns } from "./SpesialisasiList.vue?vue&type=template&id=071db041"
import script from "./SpesialisasiList.vue?vue&type=script&lang=js"
export * from "./SpesialisasiList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports